import { useQuery } from '@tanstack/react-query'
import {
	type HttpGetSubgeosParams,
	httpGetSubgeos
} from '@/features/subgeo/http/get-subgeos.http'
import { transformApiSubgeoToSubgeo } from '@/features/subgeo/types'
import { QUERY_KEYS } from '@/query-client'

import type { ResponseType } from '@/types'

interface UseGetSubgeosParams {
	geoId: string
	responseType?: ResponseType
	limit?: number
	page?: number
	name?: string
}

export const useGetSubgeos = (
	promiseArgs: UseGetSubgeosParams,
	options?: { enabled?: boolean }
) => {
	const params: HttpGetSubgeosParams = {
		responseType: promiseArgs.responseType || 'extended',
		geoId: promiseArgs.geoId,
		...(promiseArgs.limit && { limit: promiseArgs.limit }),
		...(promiseArgs.page && { page: promiseArgs.page }),
		...(promiseArgs.name && { name: promiseArgs.name })
	}

	const query = useQuery({
		queryKey: [QUERY_KEYS.GET_SUBGEOS, params],
		queryFn: () => httpGetSubgeos(params),
		enabled: options?.enabled && !!params.geoId,
		select: (data) => ({
			...data,
			subgeos: data.data.map((apiSubgeo) =>
				transformApiSubgeoToSubgeo(apiSubgeo)
			)
		})
	})

	return {
		...query,
		subgeos: query.data?.subgeos ?? []
	}
}
